import { Tooltip } from "@chakra-ui/react"
export default Tooltip